<script setup lang="ts">
import type { SuiteDailyTodo } from '@/stores/useActivityStore'
import { useActivitiesStore } from '@/stores/useActivityStore'
import { storeToRefs } from 'pinia'

defineProps<{
  todo: SuiteDailyTodo
}>()

const activitiesStore = useActivitiesStore()
const { loading } = storeToRefs(activitiesStore)

const done = async (uuid: string) => {
  await activitiesStore.completeSuiteTodo(uuid)
}
</script>

<template>
  <div
    class="rounded-xl flex w-full p-2 my-3 items-center justify-between gap-2"
    style="background-color: #c9f5f0"
  >
    <div class="flex flex-col min-w-0">
      <p class="text-lg font-medium truncate">{{ todo.title }}</p>
      <p v-if="todo.dueDate" class="text-xs opacity-70">
        {{ new Date(todo.dueDate).toLocaleString('fr-FR') }}
      </p>
    </div>
    <button
      type="button"
      class="btn btn-sm btn-ghost shrink-0"
      :disabled="loading"
      @click="done(todo.uuid)"
    >
      Terminer
    </button>
  </div>
</template>
